import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ApiResponse } from '../model/api-response.model';

export const ApiResponseInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn,
): Observable<HttpEvent<any>> => {
  return next(req).pipe(
    map((event) => {
      if (event instanceof HttpResponse) {
        const body = event.body as ApiResponse<unknown>;

        if (body && typeof body === 'object' && 'success' in body) {
          if (!body.success) {
            throw (
              body.error ?? {
                code: 'UNKNOWN_ERROR',
                message: 'Request failed',
              }
            );
          }

          return event.clone({ body: body.data });
        }
      }

      return event;
    }),

    catchError((error: HttpErrorResponse | any) => {
      if (error instanceof HttpErrorResponse) {
        const apiError = error.error?.error;

        if (apiError?.code && apiError?.message) {
          return throwError(() => apiError);
        }

        return throwError(() => ({
          code: String(error.status),
          message: error.message || 'HTTP error',
        }));
      }

      if (error?.code && error?.message) {
        return throwError(() => error);
      }

      return throwError(() => ({
        code: 'UNKNOWN_ERROR',
        message: 'Unexpected error occurred',
      }));
    }),
  );
};
